import React, { useState, useRef } from 'react';
import SubjectLineGenerator from './SubjectLineGenerator';
import SubjectLineList from './SubjectLineList';


function SubjectLineApp() {
const [subjects, setSubjects] = useState([]);

  // Create the reference point
  const resultsRef = useRef(null);

const handleGenerate = async (formData) => {
  const res = await fetch("/api/generate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
     // formData is the object containing name, desc, tone, and campaign
      body: JSON.stringify(formData), 
  });
  const data = await res.json();
  // Ensure you're targeting the right key from your node response
  setSubjects(data.subjects); 

    // Trigger the scroll after a tiny delay to ensure DOM is rendered
      setTimeout(() => {
        resultsRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }, 100);


};

return (
  <div className="">
     <SubjectLineGenerator onGenerate={handleGenerate} />

     <div ref={resultsRef} className="mt-10">
        {subjects.length > 0 && <SubjectLineList subjects={subjects} />}
      </div>

  </div>
);
}

export default SubjectLineApp;